<div class="cv-studio-pane-header">
  <h2>{{ 'cv_studio.theme_label' | translate }}</h2>
</div>
<p class="cv-studio-pane-description">{{ 'cv_studio.theme_description' | translate }}</p>

<bst-cv-theme-admin [clientId]="clientId"></bst-cv-theme-admin>
